import React from 'react';
import Dropdown from '../../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../../Services/Language/useLanguageHook';
import { DairyRevenueProtectionCalculationInputs, protectionFactorOptions } from '../DairyRevenueProtectionDefinitions';

interface IDairyRevenueProtectionFactorDropdownProps {
    calculationInputs: DairyRevenueProtectionCalculationInputs;
    setCalculatorInputs: (value: DairyRevenueProtectionCalculationInputs) => void;
}

const DairyRevenueProtectionFactorDropdown: React.FC<IDairyRevenueProtectionFactorDropdownProps> = (props: IDairyRevenueProtectionFactorDropdownProps) => {
    const [translations] = useLanguage();

    return (
        <Dropdown
            value={props.calculationInputs.protectionFactor}
            options={protectionFactorOptions}
            handleOptionChange={(value) => props.setCalculatorInputs({ ...props.calculationInputs, protectionFactor: value })}
            label={translations.risk.margin.fields.protectionFactor}
            track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'DairyProtectionFactorChanged' }}
        />
    );
};

export default DairyRevenueProtectionFactorDropdown;
